import { createFormatter } from 'reacticoon/format'

import forEach from 'lodash/forEach'
import sortBy from 'lodash/sortBy'
import map from 'lodash/map'
import isEmpty from 'lodash/isEmpty'
import { formatPrice } from 'modules/currency/format'
import { deepClone } from 'fast-json-patch'

export const formatInventoryInventory = (publicVariables, inventoryData) => (data, name) => {
  const isDataObject = typeof data === 'object' && data !== null
  const actualName = isDataObject && "name" in data ? data.name : name;
  const publicItem = ((publicVariables || {}).items || []).find((item) => item.name === actualName || item.realName === actualName) || {}
  
  const item = {
    actualName,
    ...publicItem,
    ...(isDataObject ? data : {}),
  }
  
  item.originalLabel = item.label || item.name
  item.label = item.data?.label || item.label || item.name
  item.hasCustomLabel = item.originalLabel !== item.label
  item.count = isDataObject ? (data.count || 1) : data

  // meta == different items
  // For player inventory: meta is an array with metadata for some items
  // The remaining items (count - sum of meta counts) have no metadata
  if (!item.meta || (Array.isArray(item.meta) && item.meta.length === 0)) {
    // No metadata at all - single entry
    item.meta = {}

    // Inventaire joueur : le rawData est porté par l'item lui-même (et non par
    // une meta). Comme pour les metas, `data` est camelisé par le middleware
    // (bags_1 -> bags1) et ne correspond donc plus à ce que le serveur de jeu a
    // stocké : toute action qui doit matcher la donnée exacte (retrait d'objet)
    // doit repartir de originalData.
    if (item.rawData) {
      try {
        item.originalData = JSON.parse(item.rawData)
      } catch (e) {}
    }

    inventoryData.push(item)
    return
  }

  // Has metadata - need to split into multiple entries
  let withoutMetaCount = item.count
  
  item.meta.forEach((m, index) => {
    withoutMetaCount -= m.count
    const metaItem = deepClone(item)
    metaItem.count = m.count
    metaItem.meta = m
    metaItem.label = m.data?.label || item.label 
    metaItem.hasCustomLabel = item.originalLabel !== metaItem.label
    
    // API gives the meta as raw, because we camelize our data, and should not with the meta
    if (m.rawData) {
      m.originalData = JSON.parse(m.rawData)
      metaItem.originalData = m.originalData
    }

    // Copy propertyAccess from meta to metaItem for easier access
    // Always copy even if null to show "Propriété introuvable" for keys
    if ('propertyAccess' in m) {
      metaItem.propertyAccess = m.propertyAccess
    }

    inventoryData.push(metaItem)
  })

  // Add remaining items without metadata as a separate entry
  if (withoutMetaCount > 0) {
    const itemWithoutMeta = deepClone(item)
    itemWithoutMeta.count = withoutMetaCount
    itemWithoutMeta.meta = {}
    itemWithoutMeta.label = item.originalLabel
    itemWithoutMeta.hasCustomLabel = false
    inventoryData.push(itemWithoutMeta)
  }
}

export const formatInventory = createFormatter((inventory, { publicVariables }) => {
  inventory.isEmpty = (isEmpty(inventory.inventory) && isEmpty(inventory.loadout) && inventory.money === 0 && inventory.chips === 0 && inventory.blackMoney === 0)

  inventory.moneyFormatted = formatPrice(inventory.money || 0)
  inventory.chipsFormatted = formatPrice(inventory.chips || 0, '')
  inventory.blackMoneyFormatted = formatPrice(inventory.blackMoney || 0)

  inventory.accountsData = [
    {
      label: 'Cash',
      accountType: 'money',
      amount: inventory.money || 0,
      amountFormmated: inventory.moneyFormatted
    },
    {
      label: 'Jetons',
      accountType: 'chips',
      amount: inventory.chips || 0,
      amountFormmated: inventory.chipsFormatted
    },
    {
      label: 'Argent sale',
      accountType: 'blackMoney',
      amount: inventory.blackMoney || 0,
      amountFormmated: inventory.blackMoneyFormatted
    },
  ]

  const inventoryData = []
  forEach(inventory.inventory, formatInventoryInventory(publicVariables, inventoryData))

  inventory.inventoryData = inventoryData
  // Trier par le label affiché (personnalisé ou original) et non par le nom de base
  inventory.inventoryData = sortBy(inventory.inventoryData, l => l.label?.toLowerCase())

  inventory.loadoutData = map(inventory.loadout, (data, id) => {
    const item = {
      id,
      ...data,
      label: data.name.replace("WEAPON_", ""),
      ...((publicVariables.weapons || []).find((item) => item.name === data.name) || {}),
    }

    // API gives the meta has raw, because we camelize our data, and should not with the meta
    if (item.rawData) {
      item.originalData = JSON.parse(item.rawData)
    }

    return item
  })
  inventory.loadoutData = sortBy(inventory.loadoutData, l => l.label?.toLowerCase())
  return inventory
})
